export default __webpack_public_path__ + "static/media/healthcare.a7cc53a9.svg";